<script>
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.5453 19.0583C31.294 19.0583 31.0907 19.2635 31.0907 19.5173V27.6152C31.0907 28.0567 30.7287 28.4148 30.2834 28.4148H1.70063C1.26464 28.4148 0.909314 28.0567 0.909314 27.6152V19.5173C0.909314 19.2635 0.705985 19.0583 0.454657 19.0583C0.203329 19.0583 0 19.2635 0 19.5173V27.6152C0 28.5629 0.762651 29.3328 1.70063 29.3328H30.2834C31.23 29.3328 32 28.5629 32 27.6152V19.5173C32 19.2635 31.796 19.0583 31.5453 19.0583ZM14.9157 22.6096C15.2424 22.9394 15.6717 23.1217 16.1251 23.1217C16.577 23.1217 17.0064 22.9394 17.353 22.5894L22.5556 16.6451C22.7223 16.4547 22.7043 16.1646 22.5163 15.997C22.3276 15.8294 22.0409 15.8469 21.8749 16.0367L16.691 21.9608C16.3757 22.2784 15.8577 22.263 15.5731 21.9762L10.2145 16.032C10.0459 15.8442 9.75852 15.8308 9.57253 16.0017C9.3872 16.172 9.37386 16.4621 9.54253 16.6498L14.9157 22.6096ZM15.5283 17.5677V3.79134C15.5283 3.53828 15.7317 3.33301 15.983 3.33301C16.2343 3.33301 16.4376 3.53828 16.4376 3.79134V17.5677C16.4376 17.8207 16.2343 18.026 15.983 18.026C15.7317 18.026 15.5283 17.8207 15.5283 17.5677Z"
        fill={color}
    ></path>
    <mask
        id="mask0_9355_21807"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="32"
        height="27"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.5453 19.0583C31.294 19.0583 31.0907 19.2635 31.0907 19.5173V27.6152C31.0907 28.0567 30.7287 28.4148 30.2834 28.4148H1.70063C1.26464 28.4148 0.909314 28.0567 0.909314 27.6152V19.5173C0.909314 19.2635 0.705985 19.0583 0.454657 19.0583C0.203329 19.0583 0 19.2635 0 19.5173V27.6152C0 28.5629 0.762651 29.3328 1.70063 29.3328H30.2834C31.23 29.3328 32 28.5629 32 27.6152V19.5173C32 19.2635 31.796 19.0583 31.5453 19.0583ZM14.9157 22.6096C15.2424 22.9394 15.6717 23.1217 16.1251 23.1217C16.577 23.1217 17.0064 22.9394 17.353 22.5894L22.5556 16.6451C22.7223 16.4547 22.7043 16.1646 22.5163 15.997C22.3276 15.8294 22.0409 15.8469 21.8749 16.0367L16.691 21.9608C16.3757 22.2784 15.8577 22.263 15.5731 21.9762L10.2145 16.032C10.0459 15.8442 9.75852 15.8308 9.57253 16.0017C9.3872 16.172 9.37386 16.4621 9.54253 16.6498L14.9157 22.6096ZM15.5283 17.5677V3.79134C15.5283 3.53828 15.7317 3.33301 15.983 3.33301C16.2343 3.33301 16.4376 3.53828 16.4376 3.79134V17.5677C16.4376 17.8207 16.2343 18.026 15.983 18.026C15.7317 18.026 15.5283 17.8207 15.5283 17.5677Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_9355_21807)"> </g>
</svg>
